import {
  SEARCH_AGENT_ERROR,
  SEARCH_AGENT_START,
  SEARCH_AGENT_SUCCESS,
} from 'constants/action-types/user/searchAgent';

export default (state, { type, payload }) => {
  switch (type) {
    case SEARCH_AGENT_START:
      return {
        ...state,
        searchAgent: {
          ...state.searchAgent,
          loading: true,
          error: null,
        },
      };
    case SEARCH_AGENT_ERROR:
      return {
        ...state,
        searchAgent: {
          ...state.searchAgent,
          error: payload,
          loading: false,
        },
      };
    case SEARCH_AGENT_SUCCESS:
      return {
        ...state,
        searchAgent: {
          ...state.searchAgent,
          meta: payload.meta,
          loading: false,
          items: payload.data,
        },
      };
    default:
      return null;
  }
};
